import React from 'react'
import { Button, Form, FormGroup, Input, InputGroup, InputGroupAddon, Label, Nav } from 'reactstrap'
import Loader from 'react-loader-spinner'
import { subscriptionHelpers } from '../../../dataHelpers'
import { getStorage, TOKEN_STORAGE_KEY, getCurrentTeam } from '../../../dataHelpers/authenticationHelpers'
import AppError from "../../../models/AppError"
import { getControllers } from "../../../api"
import { ErrorModal } from '../../ui'
import '../../../stylesheets/ControllerDashboard.css'
import '../../../stylesheets/odometer-theme-default.css'
import {
    SUCCESS, SUB_PLAN_CREATED, NO_VALUE, NO_YEAR, ENTER_SUBS_PLAN, ENTER_SUBS_PLAN_PRICE, ENTER_SUBS_PLAN_DAYS,
    VALID_SUBS_PLAN_DAYS, VALID_SUBS_PLAN_PRICE, SELECT_PLAN_YEAR
} from '../../../constants'

class AddSubscription extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            errors: [],
            currentControllerPage: 1,
            controllers: [],
            planNameVal: '',
            freePlanVal: '',
            isFreePlan: false,
            loading: false,
            planPrice: '',
            planYear: ''
        }
        this.token = (props.token || JSON.parse(getStorage().getItem(TOKEN_STORAGE_KEY)))
        this.submitForm = this.submitForm.bind(this)
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
    }

    dismissError(error) {
        let errors = this.state.errors.filter((e) => e !== error)
        this.setState({ errors, loading: false })
    }

    componentDidMount() {
        this.fetchControllers()
    }

    async submitForm(e) {
        e.preventDefault()
        this.setState({ loading: true })
        let { planNameVal, isFreePlan, freePlanVal, planPrice, planYear } = this.state

        if (!planNameVal || !planNameVal.length) {
            let appError = new AppError(NO_VALUE, ENTER_SUBS_PLAN)
            await this.setState({ errors: [appError], loading: false })
            return
        }

        if (isFreePlan) {
            if (!freePlanVal || !freePlanVal.length) {
                let appError = new AppError(NO_VALUE, ENTER_SUBS_PLAN_DAYS)
                await this.setState({ errors: [appError], loading: false })
                return
            }
            if (!freePlanVal.match(/^\d+(\.\d+)?$/)) {
                let appError = new AppError(NO_VALUE, VALID_SUBS_PLAN_DAYS)
                await this.setState({ errors: [appError], loading: false })
                return
            }
            this.setState({ planPrice: '', planYear: '' })
        } else {
            if (!planPrice || !planPrice.length) {
                let appError = new AppError(NO_VALUE, ENTER_SUBS_PLAN_PRICE)
                await this.setState({ errors: [appError], loading: false })
                return
            }
            if (!planPrice.match(/^\d+(\.\d+)?$/)) {
                let appError = new AppError(NO_VALUE, VALID_SUBS_PLAN_PRICE)
                await this.setState({ errors: [appError], loading: false })
                return
            }
            if (!planYear || !planYear.length) {
                let appError = new AppError(NO_YEAR, SELECT_PLAN_YEAR)
                await this.setState({ errors: [appError], loading: false })
                return
            }
            this.setState({ freePlanVal: '' })
        }

        let createSubsPlanResponse = await subscriptionHelpers.createSubsPlan(this.token, planNameVal, isFreePlan, freePlanVal)
        if (!createSubsPlanResponse.error) {
            if (isFreePlan) {
                let appError = new AppError(SUCCESS, SUB_PLAN_CREATED)
                await this.setState({ errors: [appError], loading: false, planNameVal: '', isFreePlan: false, freePlanVal: '' })
                return
            } else {
                // Create subscription plan price
                let subsPlanId = createSubsPlanResponse.id
                let createSubsPriceResponse = await subscriptionHelpers.createSubsPrice(this.token, subsPlanId, planPrice, planYear)
                if (!createSubsPriceResponse.error) {
                    let appError = new AppError(SUCCESS, SUB_PLAN_CREATED)
                    await this.setState({ errors: [appError], loading: false, planNameVal: '', planPrice: '', planYear: '' })
                    return
                } else {
                    this.setState({ errors: [createSubsPriceResponse.error] })
                }
            }
        } else {
            this.setState({ errors: [createSubsPlanResponse.error] })
        }
    }

    async fetchControllers() {
        try {
            this.setState({ loading: true })
            let teamID = getCurrentTeam()
            let { results } = await getControllers(this.token, teamID, false, false, this.state.currentControllerPage)
            this.setState({ controllers: results })
        } catch (error) {
            console.log(error)
        }
        this.setState({ loading: false })
    }

    handleCheckboxChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    render() {
        let { loading, controllers, planNameVal, errors, freePlanVal, isFreePlan, planPrice, planYear } = this.state
        let today = new Date()
        let currentYear = today.getFullYear()
        let nextYear = currentYear + 1

        return (<div>
            <div className="row justify-content-center align-items-center bg-light large-rounded border-light-sf-orange p-0 pb-4">
                <h1 className="text-center mb-4 form-head col-12">Create New Subscription Plan</h1>
                {loading ?
                    <Loader type="TailSpin" width={60} height={60} /> :
                    <Form onSubmit={this.submitForm} className="col-lg-6 col-md-8 col-sm-10">
                        <FormGroup>
                            <br />
                            <div className="text-left">
                                <Label>Subscription Plan Name</Label>
                                <InputGroup>
                                    <Input type="planName"
                                        placeholder={`Subscription Plan Name`}
                                        value={planNameVal}
                                        onChange={(evt) => this.setState({ planNameVal: evt.target.value })}
                                        maxLength={50}
                                    />
                                </InputGroup>
                            </div><br />
                            <div className="text-left" style={{ marginLeft: '20px' }}>
                                <Input type="checkbox"
                                    name="isFreePlan"
                                    checked={this.state.isFreePlan}
                                    onChange={this.handleCheckboxChange}
                                />&ensp;
                            <Label>Set as Free Trial Plan</Label>
                            </div>
                            <br />
                            {isFreePlan ?
                                <div className="text-left">
                                    <Label>Initial Free Trial Days</Label>
                                    <InputGroup>
                                        <Input type="freePlanVal"
                                            placeholder={`0`}
                                            value={freePlanVal}
                                            onChange={(evt) => this.setState({ freePlanVal: evt.target.value })}
                                            maxLength={3}
                                        />
                                        <InputGroupAddon addonType="append">days</InputGroupAddon>
                                    </InputGroup>
                                </div>
                                :
                                <div>
                                    <div className="text-left">
                                        <Label>Subscription Plan Price</Label>
                                        <InputGroup>
                                            <InputGroupAddon addonType="prepend">$</InputGroupAddon>
                                            <Input type="planName"
                                                placeholder={`0`}
                                                value={planPrice}
                                                onChange={(evt) => this.setState({ planPrice: evt.target.value })}
                                                maxLength={10}
                                            />
                                        </InputGroup>
                                    </div><br />
                                    <div className="text-left">
                                        <Label>Subscription Plan Year</Label>
                                        <InputGroup>
                                            <Input type="select" name="selectPlanYear"
                                                onChange={(evt) => this.setState({ planYear: evt.target.value })}
                                            >
                                                <option value=""></option>
                                                <option value={currentYear}>&ensp;{currentYear}</option>
                                                <option value={nextYear}>&ensp;{nextYear}</option>
                                            </Input>
                                        </InputGroup>
                                    </div>
                                    <br />
                                </div>
                            }
                        </FormGroup>
                        <Button className="mt-3">Create Subscription Plan</Button>
                    </Form>
                }
                {errors.map((appError, idx) =>
                    <ErrorModal key={`error-${appError.text}-${idx}`}
                        modal={true}
                        toggle={() => (this.dismissError(appError))}
                        text={appError.text}
                        title={appError.title} />
                )}
            </div>
        </div>)
    }
}
export default AddSubscription



// WEBPACK FOOTER //
// ./src/components/pages/subscription/AddSubscription.js